import { z } from "zod";

const YearlyDataSchema = z.object({
    year: z.number().int(),
    room_type_id: z.string().nullable(),
    occupancy: z.coerce.string().regex(/^\d+(\.\d+)?$/, {
        message: "Occupancy must be a decimal number in string format.",
    })
});

const OccupancyYearlyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(YearlyDataSchema),
});

export type OccupancyYearlyResponse = z.infer<typeof OccupancyYearlyResponseSchema>;
export { OccupancyYearlyResponseSchema };
